import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../api/client";

const ParamsContext = createContext({});

export function ParamsProvider({ children }) {
  const [params, setParams] = useState({});

  useEffect(() => {
    api.get("/parametres").then(setParams).catch(() => setParams({}));
  }, []);

  return <ParamsContext.Provider value={params}>{children}</ParamsContext.Provider>;
}

export function useParams2() { return useContext(ParamsContext); }
